import singlePostWithCustomHeading from './single-post-with-custom-heading';
import singlePostWithNativeBlock from './single-post-with-native-block';

const variations = [singlePostWithCustomHeading, singlePostWithNativeBlock];

export default variations;
